export const SOUVENIR_CATEGORY = "SOUVENIR";

export const applyPickupLeadTime = (
  itemDetail: Record<string, any>,
  itemDetailFromForm: Record<string, any> | undefined,
  category: string,
) => {
  if (category === SOUVENIR_CATEGORY) {
    itemDetail.pickup_lead_time = itemDetailFromForm?.pickup_lead_time;
  } else {
    delete itemDetail.pickup_lead_time;
  }
  return itemDetail;
};
